module.exports = __webpack_public_path__ + "static/media/wunderlist.f7d2118f.jpg";